webpackJsonp([20562568967213],{

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	var _assertString = __webpack_require__(85);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	var _assertString = __webpack_require__(85);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(143);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _isByteLength = __webpack_require__(334);
	
	var _isByteLength2 = _interopRequireDefault(_isByteLength);
	
	var _isFQDN = __webpack_require__(336);
	
	var _isFQDN2 = _interopRequireDefault(_isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFDQN;
	
	var _assertString = __webpack_require__(85);
	
	var _assertString2 = _interopRequireDefault(_assertString);
	
	var _merge = __webpack_require__(143);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFDQN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	    // disallow spaces
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    // disallow full-width chars
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Auth = Auth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _reactReduxForm = __webpack_require__(27);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _isEmail2 = __webpack_require__(335);
	
	var _isEmail3 = _interopRequireDefault(_isEmail2);
	
	var _authModule = __webpack_require__(244);
	
	var _authModule2 = _interopRequireDefault(_authModule);
	
	var _Input = __webpack_require__(67);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _redux = __webpack_require__(17);
	
	var _FAQ = __webpack_require__(42);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_authModule2.default);
	var propTypes = {
	  location: _propTypes2.default.object,
	  onSigninSubmit: _propTypes2.default.func.isRequired,
	  onSignupSubmit: _propTypes2.default.func.isRequired,
	  loginMessage: _propTypes2.default.string,
	  loginError: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loginError: state.Auth.loginError,
	    loginMessage: state.Auth.loginMessage
	  };
	};
	var mapDispatchToProps = {
	  onSigninSubmit: _redux.onSigninSubmit,
	  onSignupSubmit: _redux.onSignupSubmit
	};
	
	function Auth(_ref) {
	  var loginError = _ref.loginError,
	      loginMessage = _ref.loginMessage,
	      location = _ref.location,
	      onSigninSubmit = _ref.onSigninSubmit,
	      onSignupSubmit = _ref.onSignupSubmit;
	
	  var isSignin = location.pathname === '/signin';
	  var handleSubmit = isSignin ? onSigninSubmit : onSignupSubmit;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: cx('auth') },
	      _react2.default.createElement(
	        'div',
	        { className: cx('container') },
	        _react2.default.createElement(
	          'header',
	          { className: cx('header') },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/signup' },
	            _react2.default.createElement(
	              'div',
	              { className: cx({ underline: !isSignin }) },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Sign Up'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/signin' },
	            _react2.default.createElement(
	              'div',
	              { className: cx({ underline: isSignin }) },
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Sign In'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactReduxForm.Form,
	          {
	            className: cx('form'),
	            model: 'forms.user',
	            onSubmit: handleSubmit
	          },
	          !isSignin && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Input2.default, {
	              label: 'First Name',
	              messages: {
	                length: 'First name must be at least 2 characters',
	                required: 'First name is required'
	              },
	              model: '.firstname',
	              type: 'text',
	              validators: {
	                length: function length() {
	                  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                  return val.length > 2;
	                },
	                required: function required() {
	                  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                  return val.length;
	                }
	              }
	            }),
	            _react2.default.createElement(_Input2.default, {
	              label: 'Last Name',
	              messages: {
	                length: 'Last name must be at least 2 characters',
	                required: 'Last name is required'
	              },
	              model: '.lastname',
	              type: 'text',
	              validators: {
	                length: function length() {
	                  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                  return val.length > 2;
	                },
	                required: function required() {
	                  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                  return val.length;
	                }
	              }
	            })
	          ),
	          loginMessage && isSignin ? _react2.default.createElement(
	            'p',
	            null,
	            loginMessage
	          ) : null,
	          _react2.default.createElement(_Input2.default, {
	            label: 'Email Address',
	            messages: {
	              isEmail: 'Email is not currectly formatted'
	            },
	            model: '.email',
	            type: 'email',
	            validators: {
	              isEmail: function isEmail() {
	                var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                return (0, _isEmail3.default)(val);
	              }
	            }
	          }),
	          _react2.default.createElement(_Input2.default, {
	            label: 'Password',
	            messages: {
	              length: 'Password must be at least 6 characters'
	            },
	            model: '.password',
	            type: 'password',
	            validators: {
	              length: function length() {
	                var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                return val.length > 6;
	              }
	            }
	          }),
	          loginError && isSignin ? _react2.default.createElement(
	            'p',
	            null,
	            loginError
	          ) : null,
	          _react2.default.createElement(
	            'button',
	            { className: cx('submit'), type: 'submit' },
	            'Let\'s GO!'
	          )
	        ),
	        _react2.default.createElement('div', null)
	      )
	    ),
	    _react2.default.createElement(_FAQ2.default, { type: 'signin' })
	  );
	}
	Auth.displayName = 'Auth';
	Auth.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Auth);

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"auth":"_2OTG3RxE5tFAmVFOalZlnp","container":"wI62vVvf-AIf-G5CBeKM3","header":"E9iZ69Ad2-g3j9Nviii2H","underline":"_2qRi9EuZtfGunaCY1OM9Gi","submit":"_1g6XsXE8HIWnL248JZrl_p"};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Auth = __webpack_require__(202);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Auth).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Auth = __webpack_require__(203);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Auth).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sign-in-jsx-27bccc6c8d22f4d8a4b3.js